import { render, staticRenderFns } from "./CommissionsLogList.vue?vue&type=template&id=0d981e89"
import script from "./CommissionsLogList.vue?vue&type=script&lang=js"
export * from "./CommissionsLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports